/* eslint-disable no-param-reassign */
export default (state, { payload: { token, data } }) => {
  state.currentAccountChannels[token] ??= {};
  Object.assign(state.currentAccountChannels[token], data);
};
